<template>
  <div class="commentsContainer pa-4" style="height: 100%">
    <div v-if="loading" class="pa-4 d-flex align-center justify-center"></div>
    <template v-if="comments.length">
      <div class="mb-2" v-for="(item, index) in comments" :key="`assembly-comment-${index}`">
        <CommentCard 
          :comment="item" 
          :index="index"
          @comment-updated="onCommentUpdated"
          @comment-deleted="onCommentDeleted"></CommentCard>
      </div>

      <AddCommentCard
        class="my-3"
        v-if="commenting"
        :user="user"
        @post-comment="addingComment"
        @close-adding="commenting = false" />

      <div class="d-flex justify-center w-100 my-3" v-else>
        <v-btn
          rounded
          outlined
          color="primary"
          @click="onToggleAddComment"
          v-has="[permissions.Tasks.Create, permissions.Tasks.Update]">
          <v-icon>mdi-plus</v-icon> Add Comment
        </v-btn>
      </div>
    </template>
    <div
      id="no-comments"
      v-else
      class="d-flex h-100 flex-column align-center"
      :class="{ 'justify-center': !commenting }">
      <AddCommentCard
        v-if="commenting"
        :user="user"
        @post-comment="addingComment"
        @close-adding="commenting = false"></AddCommentCard>
      <div class="d-flex flex-column align-center" v-else>
        <img width="205" height="205" contain="true" src="@Assets/images/chatImg.png" />
        <div class="my-10 font-weight-bold" style="color: var(--v-mid-grey2-base)">
          There is no comments added yet
        </div>
        <v-btn
          rounded
          outlined
          color="primary"
          @click="onToggleAddComment"
          v-has="[permissions.Tasks.Create, permissions.Tasks.Update]">
          <v-icon>mdi-plus</v-icon> Add Comment
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import CommentCard from '../components/CommentCard.vue';
  import AddCommentCard from '../components/AddCommentCard.vue';
  import { mapGetters } from 'vuex';
  import permissions from '@Share/config/permissions';
  export default {
    components: {
      CommentCard,
      AddCommentCard,
    },
    data() {
      return {
        taskId: null,
        newComment: '',
        permissions,
        commenting: false,
      };
    },
    computed: {
      ...mapGetters('ACCOUNT', {
        user: 'GET_USER',
      }),
      ...mapGetters('TASK_COMMENTS', {
        loading: 'GET_LOADING',
        addLoading: 'GET_UPDATE_LOADING',
        comments: 'GET_ENTRIES',
        total: 'GET_TOTAL',
        options: 'GET_OPTIONS',
      }),
    },
    methods: {
      open(id) {
        this.taskId = id;
        this.$store.dispatch('TASK_COMMENTS/GET', this.taskId);
      },
      onToggleAddComment() {
        this.commenting = true;
        const element = document.querySelector('.commentsContainer');
        setTimeout(() => {
          element.scrollTop = element.scrollHeight;
        }, 0);
      },
      addingComment(newComment) {
        if (newComment?.trim())
          this.$store
            .dispatch('TASK_COMMENTS/UPDATE', {
              taskId: this.taskId,
              content: newComment,
            })
            .then((res) => {
              newComment = '';
              this.commenting = false;
              this.$emit('onAdd', res);
            });
      },
      onCommentUpdated(updatedComment) {
        // Find and update the comment in the local comments array
        const commentIndex = this.comments.findIndex(c => c.id === updatedComment.id);
        if (commentIndex !== -1) {
          // Update the comment in place to trigger reactivity
          this.$set(this.comments, commentIndex, updatedComment);
        }
        
        // Emit event to parent component (EditTask) to handle any additional updates
        this.$emit('onUpdate', updatedComment);
      },
      onCommentDeleted(deletedComment) {
        // Emit event to parent component (EditTask) to handle comment deletion
        this.$emit('onDelete', deletedComment);
      },
    },
    mounted() {
      this.$store.dispatch('USER/GET');
      document.onkeydown = function (e) {
        if (e.ctrlKey && e.key == 'Enter') {
          this.addingComment();
        }
      }.bind(this);
    },
    destroyed() {},
    watch: {},
  };
</script>

<style>
  .commentBox {
    padding: 20px;
    width: 100%;
    gap: 10px;
    border-radius: 7px;
    border: 1px solid var(--v-primary-base);
    gap: 5px;
    box-shadow: 0px 4px 8px 0px var(--v-light-grey-base);
  }
</style>
